import { Injectable } from '@angular/core';
import { GetBeneficiaryRequiredFieldsAction } from '@app/finxone-web-frontend/app/lib/actions/beneficiary.action';
import {
  SetCopResponseStateMatchStatusCode,
  SetCopResponseStateName,
  SetCopResponseStateReason,
} from '@app/finxone-web-frontend/app/lib/actions/cop-response.action';
import { GetDepositAccountInfo } from '@app/finxone-web-frontend/app/lib/actions/deposit-account-info.action';
import {
  SetFormAction,
  SetFormActionWithId,
  UpdateFormDataAction,
} from '@app/finxone-web-frontend/app/lib/actions/form-submission.action';
import { SetPaymentRequestSummary } from '@app/finxone-web-frontend/app/lib/actions/notification.action';
import {
  GetAvailableSavingsProducts,
  SetPispDepositInitiateResponse,
  UpdateInternalTransferFromAccountId,
  UpdateInternalTransferToAccountId,
} from '@app/finxone-web-frontend/app/lib/actions/savings-account.action';
import { FetchTotalWealth } from '@app/finxone-web-frontend/app/lib/actions/total-wealth.action';
import {
  GetTransactionById,
  GetTransactionReceiptFileId,
} from '@app/finxone-web-frontend/app/lib/actions/transactions.action';
import { FormActionTypeEnum, FormID } from '@finxone-platform/form-action';
import { noMatch } from '@finxone-platform/shared/default-templates';
import {
  ACCOUNTTYPE,
  CheckPayeeMatchStatus,
  DepositDetailsType,
  DocumentActionType,
  PISPDepositStatusEnum,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { MOCK_COMPANIES_HOUSE_OFFICERS } from './companies-house-officers.mock-data';

@Injectable({
  providedIn: 'root',
})
export class NgxsMockDataProviderService {
  private brokerFacilityFormData = {
    facilityName: 'M/Y Odessa',
    facilityType: 'type 1',
  };

  private brokenFacilityCustomQuestionFormData = {
    about: `Built in 2009 by the US yacht builder, Christensen Shipyards, ODESSA is a 48.8m (160ft) motor yacht with a beam of 9m (29.5ft). Immediately upon delivery she turned heads with her striking black hull and silver superstructure, which culminated with her winning the Best Interior Design award by Showboats Magazine.

    Her interior styling by Cristina Bernardeau offers a warm and sophisticated atmosphere. The balanced blend of walnut joinery, wide-plank walnut wood floors, neutral marbles and Armani Casa soft furnishings provides a sanctuary of luxury and comfort at sea, and complements her dynamic exterior designed by Christensen’s in-house team.

    While the yacht has an interior volume of 499GT across four decks, her well designed interior layout creates the impression of a much larger Facility. Substantial decks along with generous common areas provide guests with plenty of options to choose from for entertainment and relaxation on board.

    She has six cabins for 13 guests with a full beam owner's suite on the main deck, a full beam VIP suite on the lower deck along with four more spacious guest cabins -- two king size double cabins, one queen size double cabin and one convertible cabin. A guest elevator serves all decks and the yacht is capable of carrying an EC 130 helicopter on the sun deck aft.

    The exterior decks offer a range of entertainment options including three al fresco dining areas, a Portuguese bridge to enjoy while underway, an oversized jacuzzi on the forward sun deck and plenty of space for lounging.

    Twin 1,800hp MTU diesel engines give her a top speed of 17 knots, a cruising speed of 12 knots, a transatlantic range of 4,000nm. Quantum zero speed stabilizers ensure comfort at anchor or underway. Meticulously maintained throughout ownership, ODESSA received an interior refit in 2015, and in 2019 completed her ABS 10-year survey. This yacht presents a prime buying opportunity for an owner seeking immediate use on a turn-key Facility.`,

    'key-features': `Well designed accommodation for up to 13 guests in 6 cabins including a full beam owner’s cabin and VIP suite.

    Awarded ‘Best Interior Design’ by Showboats Magazine.

    Interior volume and deck spaces normally found on a larger yacht, yet with operating costs of a smaller Facility.

    Guest elevator serves all decks for ease and accessibility.

    Capable of carrying an EC 130 helicopter for access to and from the yacht anytime, anywhere.

    ABS and MCA compliant with her ABS 10-year survey completed in 2019.`,

    'imo-number': '1225351136189496',
    type: 'Yacht',
    built: '2009 (refitted 2015), Christensen Shipyards, United States Of America',
    beam: '9m (29.5ft)',
    length: '48.8m (160ft)',
    draft: '2.5m (8.2ft)',
    'gross-tonnage': '499',
    'cruising-speed': '12 Knots',
    'maximum-speed': '12 Knots',
    range: '4000 nm',
    flag: 'Cayman Islands',
    lying: 'USA',
    engines: '211,800hp MTU',
    class: 'ABS, MCA Compliant',
    'exterior-designer': 'ABS, MCA Compliant',
    'interior-designer': 'ABS, MCA Compliant',
    construction: 'Hull - Composite, Superstructure - Composite, Deck - Teak',
    employee: '10',
    guests: '13',
    cabins: '6 Cabins (6x1 Doubles, x1 1 additional berths)',
    tenders: '1 x 2015 Novurania 25’ LX 750 tender 1 x 2009 Nautica 15’ Widebody RIB',

    myFiles: [
      {
        id: '',
        filename: 'carousel-image.jpeg',
        path: 'assets/images/carousel-image.jpeg',
      },
    ],
  };

  private brokerCreateEventFormData = {
    facilityId: 'Facility ID',
    facilityType: 'type 1',
  };

  private brokerCreateEventCustomQuestionFormData = {
    'event-first-name': 'Jonathan',
    'event-middle-name': 'Smith',
    'event-last-name': 'Doe',
    'event-email-address': 'jonathan.doe@gmail.com',
    'event-mobile': '+101512054455',
    'event-name': 'John & Gina’s Wedding Ceremony',
    'event-budget-amount': '80,000',
    'event-number-of-guests': '10',
    'event-first-line-embark-location': 'St. Thomas, U.S. Virgin Islands off o Pier 33, End of dock',
    'event-step-3-embark-date': '2001-12-31T18:30:00+00:00',
    'event-step-3-embark-time': '2024-02-21T11:17:24.369+00:00',
    'event-second-line-embark-location': '',
    'event-first-line-disembark-location': 'St. Thomas, U.S. Virgin Islands off o Pier 33, End of dock',
    'event-second-line-disembark-location': '',
    'event-step-3-disembark-date': '2003-12-31T18:30:00+00:00',
    'event-step-3-disembark-time': '2024-02-21T12:17:24.369+00:00',
  };

  private intlBeneficiaryAddData = {
    currency: 'USD',
    countryIso2: 'US',
    name: 'Brandon Taylor',
    firstName: 'Brandon',
    lastName: 'Taylor',
    aba: '026009593',
    bankName: 'ABC Bank',
    bic: 'ABCDUS12345',
    accountNumber: '1357924580',
    addressLine1: '5160 Sunnyvale Dr',
    addressStreet: '5160 Sunnyvale Dr',
    addressCity: 'Salt Lake City',
    addressState: 'Utah',
    addressCountry: 'United States',
    addressPostCode: '84102',
    street: 'street',
    city: 'Salt Lake City',
    state: 'Utah',
    country: 'US',
    postCode: '90210',
    postalCode: '90210',
  };

  private kycFormData = {
    date_of_birth: '2005-12-31T18:30:00.000Z',
    first_name: 'Sylvia',
    middle_name: 'N',
    last_name: 'Hendricks',
    phone: '8234061062',
    country_code: '+91',
    isPhoneVerified: true,
    email: 'eren_yeager@yopmail.com',
    isEmailVerified: true,
  };

  private tripFormData = {
    entering_country: 'france',
    leaving_country: 'france',
    startDate: '2024-06-02',
    endDate: '2024-06-04',
    modeOfTravel: 'Airport',
    departureInput: 'Paris Charles de Gaulle (CDG)',
    approxTime: '03:00 - 05:00',
    'total-amount': 200.0,
    'total-vat-amount': 40.0,
    'merchant-name': 'Louis Vuitton',
    'transaction-date': '20/04/2024',
    transactionItems: [
      {
        item_name: 'Sneakers',
        item_amount: 50.0,
        item_vat: 10.0,
      },
      {
        item_name: 'Sneakers 2',
        item_amount: 40.0,
        item_vat: 5.0,
      },
    ],
  };
  private exchangeSummaryData = {
    quoteId: '7270e6c8-f539-44ca-82d5-8f2c10be19b2',
    exchangeRate: 1.234644755,
    buyCurrency: 'EUR',
    buyAmount: 3.7,
    sellCurrency: 'GBP',
    sellAmount: 3,
    feeAmount: 0,
    feeCurrency: '',
    exchangeDate: '2024-01-22',
    expiryDateTime: '2024-01-22 07:58:36 am',
    cutOffTimeInMinutes: -21,
    settlementDate: '2024-01-22',
    debitAmount: 3,
    creditAmount: 3.7,
  };

  private addEmployeeCustomQuestionFormData = {};

  private addEmployeeFormData = {
    first_name: 'John',
    middle_name: '',
    last_name: 'Doe',
    country_code: '+44',
    phone: '7619573856',
    userName: 'john_doe',
    password: 'Admin@123',
    confirm_password: 'Admin@123',
  };

  private addUserFomData = {
    addressCity: 'Salt Lake City',
    addressCountry: 'United States',
    addressPostCode: '90012',
    addressState: 'Los Angeles',
    addressStreet: '5160 Sunnyvale Dr',
    assign_persona: 'role-15',
    assign_role_permission: ['payment-requestor'],
    confirm_password: 'Admin@123',
    country_code: '+44',
    email: 'abc@finxone.com',
    first_name: 'John',
    isEmailVerified: false,
    isPhoneVerified: false,
    last_name: 'Doe',
    middle_name: '',
    password: 'Admin@123',
    phone: '7619573856',
    userName: 'john_doe',
  };

  private beneficiaryDetails = {
    bid: 'b8e8f007-11d0-4fce-8318-e4e03760b6c2',
    beneficiaryCountry: 'US',
    name: 'Brandon Taylor',
    sortCode: '123456',
    accountNumber: '12345678',
    address: {
      street: 'street',
      city: 'sinsinati',
      state: 'Utah',
      country: 'US',
      postalCode: '90210',
    },
  };

  private companiesHouseSearchData = {
    companyHouseSearchResult: [
      {
        companyName: 'FINXONE LIMITED',
        companyNumber: '12345678',
        companyStatus: 'active',
        type: 'ltd',
        dateOfCreation: '2020-01-15',
        registeredOfficeAddress: {
          address1: '10 Finxone Street',
          locality: 'London',
          postalCode: 'EC1A 1BB',
          country: 'England',
        },
      },
      {
        companyName: 'LONDON RELAY LIMITED',
        companyNumber: 'OE018472',
        companyStatus: 'registered',
        dateOfCreation: '2023-01-26',
        jurisdiction: 'united-kingdom',
        type: 'registered-overseas-entity',
        undeliverableRegisteredOfficeAddress: false,
        registeredOfficeIsInDispute: false,
        registeredOfficeAddress: {
          address1: 'De Carteret House',
          address2: '7 Castle Street',
          country: 'JE',
          locality: 'St. Helier',
          postalCode: 'JE2 3BT',
        },
        serviceAddress: {
          address1: 'De Carteret House',
          address2: '7 Castle Street',
          country: 'JE',
          locality: 'St. Helier',
          postalCode: 'JE2 3BT',
        },
        officers: {
          activeCount: 3,
          resignedCount: 0,
          totalResults: 3,
          items: [
            {
              name: 'LITTON JR., Thomas',
              officerRole: 'managing-officer',
              address: {
                addressLine1: 'Waterside Drive',
                country: 'US',
                locality: 'Norfolk',
                postalCode: '23510',
                premises: '999',
              },
              appointedOn: '2024-06-26',
              nationality: 'US',
              occupation: 'President - Harbor International Group Llc',
              dateOfBirth: {
                month: 3,
                year: 1967,
              },
            },
          ],
        },
      },
      {
        companyName: 'TECHSTART INNOVATIONS LTD',
        companyNumber: '11223344',
        companyStatus: 'active',
        type: 'ltd',
        dateOfCreation: '2018-03-10',
        registeredOfficeAddress: {
          address1: '5 Innovation Drive',
          locality: 'Bristol',
          postalCode: 'BS1 3AA',
          country: 'England',
        },
      },
      {
        companyName: 'S&R ESTATES LONDON LTD',
        companyNumber: '12489393',
        companyStatus: 'dissolved',
        type: 'ltd',
        dateOfCreation: '2020-02-28',
        registeredOfficeAddress: {
          address1: '2 Millais Road',
          country: 'GB',
          locality: 'London',
        },
      },
      {
        companyName: 'JUST MEAT (LONDON) LTD',
        companyNumber: '12489902',
        companyStatus: 'dissolved',
        type: 'ltd',
        dateOfCreation: '2020-02-28',
        registeredOfficeAddress: {
          address1: '719a-719b Green Lanes',
          country: 'GB',
          locality: 'London',
          postalCode: 'N21 3RX',
        },
      },
      {
        companyName: 'SMART GLOBE LONDON LTD',
        companyNumber: '12489900',
        companyStatus: 'dissolved',
        type: 'ltd',
        dateOfCreation: '2020-02-28',
        registeredOfficeAddress: {
          address1: '554 Streatham High Road',
          country: 'GB',
          locality: 'London',
          postalCode: 'SW16 3QG',
        },
      },
      {
        companyName: '125 RICHMOND ROAD (LONDON) LIMITED',
        companyNumber: '12490930',
        companyStatus: 'dissolved',
        type: 'ltd',
        dateOfCreation: '2020-03-02',
        registeredOfficeAddress: {
          address1: '77 Abbots Gardens',
          country: 'GB',
          locality: 'London',
          postalCode: 'N2 0JG',
          region: 'London',
        },
      },
      {
        companyName: 'YY LONDON LTD',
        companyNumber: '12492346',
        companyStatus: 'dissolved',
        type: 'ltd',
        dateOfCreation: '2020-03-02',
        registeredOfficeAddress: {
          address1: 'Flat 224 Gladwin Tower',
          address2: '50 Wandsworth Road',
          country: 'GB',
          locality: 'London',
          postalCode: 'SW8 2FU',
        },
      },
      {
        companyName: 'KALLISTO LONDON LIMITED',
        companyNumber: '12493046',
        companyStatus: 'dissolved',
        type: 'ltd',
        dateOfCreation: '2020-03-02',
        registeredOfficeAddress: {
          address1: '2 Church Road',
          address2: 'Wimbledon Village',
          country: 'GB',
          locality: 'London',
          postalCode: 'SW19 5DL',
        },
      },
      {
        companyName: 'KINI LONDON LIMITED',
        companyNumber: '12493131',
        companyStatus: 'dissolved',
        type: 'ltd',
        dateOfCreation: '2020-03-02',
        registeredOfficeAddress: {
          address1: '7 Dobson Close',
          country: 'GB',
          locality: 'London',
          postalCode: 'NW6 4RS',
        },
      },
      {
        companyName: 'ACCOUNTAX LONDON LIMITED',
        companyNumber: '12493446',
        companyStatus: 'dissolved',
        type: 'ltd',
        dateOfCreation: '2020-03-02',
        registeredOfficeAddress: {
          address1: 'Unit 19 1-13 Adler Street',
          country: 'GB',
          locality: 'London',
          postalCode: 'E1 1EG',
        },
      },
      {
        companyName: 'EAST LONDON SHUTTERS LTD',
        companyNumber: '12495284',
        companyStatus: 'dissolved',
        type: 'ltd',
        dateOfCreation: '2020-03-03',
        registeredOfficeAddress: {
          address1: 'Unit 3 18 Plumbers Row',
          country: 'GB',
          locality: 'London',
          postalCode: 'E1 1EP',
        },
      },
      {
        companyName: 'GRAB A BITE (LONDON) LTD',
        companyNumber: '12498751',
        companyStatus: 'dissolved',
        type: 'ltd',
        dateOfCreation: '2020-03-04',
        registeredOfficeAddress: {
          address1: '15 Ridley Road',
          country: 'GB',
          locality: 'Dalston',
          postalCode: 'E8 2NP',
          region: 'London',
        },
      },
    ],
  };

  private businessOnboardingFlowData = {
    companyName: 'STONE BULL LTD',
    companyNumber: '12876947',
    companyStatus: 'active',
    dateOfCreation: '2020-09-13',
    jurisdiction: 'united-kingdom',
    type: 'ltd',
    undeliverableRegisteredOfficeAddress: false,
    companyAddress: {
      address1: '20-22 Wenlock Road',
      address2: '',
      address3: '',
      country: 'GB',
      state: '',
      locality: 'London',
      postalCode: 'N1 7GU',
      premises: '',
    },
    serviceAddress: {
      address1: '20-22 Wenlock Road',
      address2: '',
      address3: '',
      country: 'GB',
      state: '',
      locality: 'London',
      postalCode: 'N1 7GU',
      premises: '',
    },
    registeredOfficeIsInDispute: false,
    activeCount: 3,
    resignedCount: 1,
    totalResults: 4,
    director: 'officer-0',
    annualBusinessTurnover: '100,000 - 500,000',
    businessWebsite: 'www.stonebull.co.uk',
    businessAddressSameAsTradingAddress: 'yes',
    tradingNameAsRegName: 'no',
    primaryOfficer: MOCK_COMPANIES_HOUSE_OFFICERS[0],
    members: MOCK_COMPANIES_HOUSE_OFFICERS,
    companyCreationDay: new Date('2020-09-13').getDate(),
    companyCreationMonth: new Date('2020-09-13').getMonth(),
    companyCreationYear: new Date('2020-09-13').getFullYear(),
  };

  private intlTransferResponse = {
    currency: 'USD',
    amount: 1000,
    feeAmount: 5,
    totalAmount: 1005,
    receiverName: 'Brandon Taylor',
    receiverAccountNumber: '1357924580',
    senderName: 'Anne Miller',
    senderAccountNumber: '1234567890',
    paymentReference: 'Test Reference',
    transactionNumber: 'P2100DYH8X',
    transferReasonIdText: 'Payment for goods and services',
  };

  constructor(store: Store) {
    store.dispatch(
      new SetFormActionWithId(
        {
          type: '',
          formData: {
            ...this.brokenFacilityCustomQuestionFormData,
            ...this.brokerCreateEventCustomQuestionFormData,
            ...this.addEmployeeCustomQuestionFormData,
            myFile: [
              {
                id: '',
                filename: 'carousel-image.jpeg',
                path: 'assets/images/carousel-image.jpeg',
              },
            ],
          },
        },
        FormActionTypeEnum.CUSTOM_QUESTION,
      ),
    );

    store.dispatch(
      new SetFormActionWithId(
        {
          type: '',
          formData: this.intlBeneficiaryAddData,
        },
        FormActionTypeEnum.INTL_BENEFICIARY_ADD,
      ),
    );

    store.dispatch(
      new SetFormActionWithId(
        {
          type: '',
          formData: this.kycFormData,
        },
        FormActionTypeEnum.KYC_DETAILS,
      ),
    );

    store.dispatch(
      new SetFormActionWithId(
        {
          type: '',
          formData: this.exchangeSummaryData,
        },
        FormActionTypeEnum.EXCHANGE_QUOTE_SUMMARY,
      ),
    );

    store.dispatch(
      new SetFormActionWithId(
        {
          type: '',
          formData: this.addEmployeeFormData,
        },
        FormActionTypeEnum.ADD_EMPLOYEE,
      ),
    );

    store.dispatch(
      new SetFormActionWithId(
        {
          type: '',
          formData: this.addUserFomData,
        },
        FormActionTypeEnum.MANAGE_USER,
      ),
    );

    store.dispatch(
      new SetFormAction({
        type: '',
        formData: this.beneficiaryDetails,
      }),
    );

    store.dispatch(
      new SetFormActionWithId(
        {
          type: '',
          formData: {
            name: 'Test User',
            accountType: ACCOUNTTYPE.PERSONAL,
            destinationIdentifier: {
              country: 'GB',
              currency: 'GBP',
              accountNumber: '12345678',
              sortCode: '123456',
              bic: 'BARCGB22',
              iban: '123456789',
            },
            address: {
              addressStreet: '5160 Sunnyvale Dr',
              addressLine1: '5160 Sunnyvale Dr',
              addressCity: 'Salt Lake City',
              addressCountry: 'US',
              addressPostCode: '84102',
              addressState: 'Utah',
            },
          },
        },
        FormActionTypeEnum.ADD_BENEFICIARY,
      ),
    );

    store.dispatch(
      new SetFormActionWithId(
        {
          type: '',
          formData: {
            name: 'Test User',
            accountType: ACCOUNTTYPE.PERSONAL,
            destinationIdentifier: {
              country: 'GB',
              currency: 'GBP',
              accountNumber: '12345678',
              sortCode: '123456',
              bic: 'BARCGB22',
              iban: '123456789',
            },
            address: {
              addressStreet: '5160 Sunnyvale Dr',
              addressLine1: '5160 Sunnyvale Dr',
              addressCity: 'Salt Lake City',
              addressCountry: 'US',
              addressPostCode: '84102',
              addressState: 'Utah',
            },
          },
        },
        FormActionTypeEnum.EDIT_BENEFICIARY,
      ),
    );
    store.dispatch(
      new SetFormActionWithId(
        {
          type: '',
          formData: this.intlTransferResponse,
        },
        FormActionTypeEnum.INTL_TRANSFER_RESPONSE,
      ),
    );

    store.dispatch(
      new SetFormActionWithId(
        {
          type: '',
          formData: this.companiesHouseSearchData,
        },
        FormActionTypeEnum.COMPANIES_HOUSE_SEARCH,
      ),
    );

    store.dispatch(
      new SetFormActionWithId(
        {
          type: '',
          formData: this.businessOnboardingFlowData,
        },
        FormActionTypeEnum.BUSINESS_ONBOARDING_FLOW,
      ),
    );

    store.dispatch(
      new SetFormActionWithId(
        {
          type: '',
          formData: {
            depositAmount: '332.45',
            sourceOfFunds: '2',
            sourceOfFundsOther: null,
            accountPurpose: '747',
            multipleTaxResidency: '1',
            countryOfOtherTaxResidency: null,
            tinNumber: null,
            tinNumberNo: null,
            tinNumberYes: null,
          },
        },
        FormID.OPEN_NEW_ACCOUNT_FORM,
      ),
    );

    store.dispatch(
      new UpdateFormDataAction({
        bid: 'D341141Y1B',
        beneficiaryCountry: 'GB',
        transferDate: `${new Date()}`,
        transferReasonIdText: 'Other',
        paymentReference: '',
        failureReason: 'Bank Server Down',
        referenceNumber: '20240508-B8XOD5',
      }),
    );

    store.dispatch(
      new SetPaymentRequestSummary({
        id: 'd1b98a5d-af23-407f-a9cd-577b309d1b07',
        amount: '10000.00',
        currency: 'GBP',
        paymentReference: 'Rent',
        paymentReason: 'Payment for goods and services',
        requester: {
          userId: '3110c5ce-01da-48bd-9558-6c2f7376a125',
          name: 'Herbert Grant',
          accountId: '41beb46f-5c0c-48b5-b5b5-c1170e8fc514',
          accountName: 'John Mark',
          destinationIdentifier: {
            accountNumber: '22783200',
            'sort-code': '123456',
          },
        },
        approver: {
          userId: 'd0a277d9-2098-4e54-9a1c-24622f4bef6a',
          name: 'David Miller',
        },
        beneficiary: {
          name: 'David Miller',
          destinationIdentifier: {
            accountNumber: '983724982',
            'sort-code': '434534',
          },
        },
        approverStatus: 'approved',
        approvedOrRejectedDate: '02/05/2024 06:08',
        status: 'success',
        createdDate: '02/05/2024 06:18',
        recordId: '',
      }),
    );

    store.dispatch(
      new SetFormActionWithId(
        {
          type: '',
          formData: {
            accountId: '123',
            currency: 'GBP',
            country: 'United Kingdom',
            accountNo: '84521321',
            sortCode: '00-00-00',
          },
        },
        FormActionTypeEnum.PROFILE_BANK_STATEMENT,
      ),
    );

    store.dispatch(new GetBeneficiaryRequiredFieldsAction('US', 'USD'));

    store.dispatch(new SetCopResponseStateName('Suggested Test User'));
    store.dispatch(new SetCopResponseStateReason(noMatch));
    store.dispatch(new SetCopResponseStateMatchStatusCode(CheckPayeeMatchStatus.CLOSE_MATCH));
    store.dispatch(new GetTransactionById('20241112-6DY3NW', '', '', ''));
    store.dispatch(new GetTransactionReceiptFileId(DocumentActionType.TRANSACTIONS, '20241112-6DY3NW'));

    store.dispatch(new GetDepositAccountInfo([DepositDetailsType.BALANCE]));
    store.dispatch(new GetDepositAccountInfo([DepositDetailsType.INTEREST]));
    store.dispatch(new GetDepositAccountInfo([DepositDetailsType.DEPOSIT_DETAILS]));
    store.dispatch(new GetDepositAccountInfo([DepositDetailsType.BALANCE_WITH_INTEREST]));

    // PISP deposit status
    store.dispatch(
      new UpdateFormDataAction({
        formData: {
          pispDepositStatus: PISPDepositStatusEnum.COMPLETED,
          withdrawalStatus: 'completed',
          savingsInternalTransferStatus: 'completed',
        },
      }),
    );

    store.dispatch(new FetchTotalWealth('GBP'));

    store.dispatch(
      new SetPispDepositInitiateResponse({
        id: 'mock-billing-request-id-001',
        paymentId: 'mock-payment-id-001',
        authorisationUrl: 'https://pay.gocardless.com/obauth/mock-auth-token',
        redirectUri: 'https://app.finxone.com/pisp-callback',
        qrCodeUrl: 'assets/images/gocardless_qr_code.png',
      }),
    );

    // Set Savings internal transfer accounts for mocking data
    store.dispatch(new UpdateInternalTransferFromAccountId('35748453'));
    store.dispatch(new UpdateInternalTransferToAccountId('35745753'));

    store.dispatch(new GetAvailableSavingsProducts());
  }
}
